import React, { ChangeEvent, FocusEvent, useState } from "react";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import Typography from "../Typography";

interface LabelDateInputFieldProps {
  label?: string;
  placeHolder?: string;
  style?: {
    container?: React.CSSProperties;
    label?: React.CSSProperties;
    input?: React.CSSProperties;
  };
  name: string;
  selectedDate?: Date | null | string;
  onChange?: (date: Date | null) => void;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
}

const Datepicker: React.FC<LabelDateInputFieldProps> = ({
  label,
  style,
  onChange,
  onBlur,
  selectedDate,
}) => {
  const [date, setDate] = useState<Date | null | string>(selectedDate || null);

  const handleChange = (date: any) => {
    setDate(date);
    if (onChange) {
      onChange(date);
    }
  };

  return (
    <div style={style?.container}>
      {label && (
        <Typography fontFamily="urbanist" style={style?.label}>
          {label}
        </Typography>
      )}
      <DatePicker
        value={selectedDate}
        onChange={(value) => {
          handleChange(value);
        }}
        onBlur={onBlur}
      />
    </div>
  );
};

export default Datepicker;
